import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface NotFoundErrorPageStyles {
    wrapper?: InjectableCss;
}

export const notFoundErrorPageStyles: NotFoundErrorPageStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: center;
            padding: 30px 0;
        `,
    },
};

const styles = notFoundErrorPageStyles;

const NotFoundErrorPage: React.FC<PageProps> = ({ id }) => (
    <Page>
        <StyledWrapper {...styles.wrapper}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
    </Page>
);

const pageModule: PageModule = {
    component: NotFoundErrorPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
